module.exports = __webpack_public_path__ + "static/media/bankid.53906e51.svg";